module.exports = __webpack_public_path__ + "img/fish.c40c84ca.svg";